import React from 'react';
import { SvgIcon } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { AppName } from '../types';

const appColors = {
  [AppName.Authors]: '#f46873',
  [AppName.Card]: '#41c6da',
  [AppName.Crud]: '#3F51B5',
  [AppName.Diapo]: '#3F51B5',
  [AppName.Newsletter]: '#FFC107',
  [AppName.Page]: '#0097A7',
  [AppName.People]: '#607D8A',
  [AppName.Photo]: '#232323',
  [AppName.Recipe]: '#E91E63',
  [AppName.Story]: '#009688',
  [AppName.Video]: '#AD1457',
  [AppName.Web]: '#F44336',
  [AppName.Dashboard]: '#F44336',
  [AppName.Orphans]: '#F44336',
};

interface AppIconProps extends Partial<SvgIconProps> {
  appName: AppName;
  white?: boolean;
}

export const AppIcon: React.FC<AppIconProps> = ({
  appName,
  white,
  ...props
}) => (
  <SvgIcon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="FavIcon_One_Amber">
        <g id="Oval">
          <g id="path-1-link" fill={white ? '#FFF' : appColors[appName]}>
            <circle id="path-1" cx="16" cy="16" r="16"></circle>
          </g>
        </g>
        <g
          id="Group"
          transform="translate(7.529412, 6.588235)"
          stroke={white ? appColors[appName] : '#FFF'}
        >
          <polygon
            id="Path-2"
            strokeWidth="1.87076921"
            points="8.28325506 0.084596064 0 5.08883646 0 14.4018558 8.28390769 19.3312856 16.6555668 14.4265954 16.6555668 5.09040863"
          ></polygon>
          <polygon
            id="Rectangle"
            strokeWidth="0.935384604"
            fillRule="nonzero"
            points="7.96518444 11.211911 8.4790673 11.211911 8.4790673 18.5126903 7.96518444 18.5126903"
          ></polygon>
        </g>
      </g>
    </g>
  </SvgIcon>
);
